import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
export default class ResetDiscussionViewsModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "discussion", void 0);
    _defineProperty(this, "currentViewsCount", void 0);
    _defineProperty(this, "newViewsCount", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.discussion = this.attrs.discussion;
    this.currentViewsCount = this.attrs.discussion.views() || 0;
    this.newViewsCount = Stream(this.currentViewsCount.toString());
  }
  className() {
    return 'Modal--small ResetDiscussionViewsModal';
  }
  title() {
    return app.translator.trans('fof-discussion-views.forum.modal_resetviews.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Form Form--centered"
    }, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('fof-discussion-views.forum.modal_resetviews.label')), m("input", {
      className: "FormControl",
      type: "number",
      min: "0",
      bidi: this.newViewsCount
    })), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('fof-discussion-views.forum.modal_resetviews.submit')))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    const newViews = parseInt(this.newViewsCount());
    const currentViews = this.currentViewsCount;
    if (isNaN(newViews) || newViews < 0) {
      this.loading = false;
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('fof-discussion-views.forum.modal_resetviews.invalid'));
      return;
    }
    if (newViews === currentViews) {
      this.hide();
      return;
    }
    this.discussion.save({
      views: newViews
    }).then(() => {
      this.hide();
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('fof-discussion-views', 'forum/components/ResetDiscussionViewsModal', ResetDiscussionViewsModal);